module.exports = __webpack_public_path__ + "img/s-1051x1318_v-fms_webp_7e462d43-72f9-489e-9938-79e3e9e5ddc2_small.c2cf301e.jpg";